
import Schema from 'AppReact/schema';
import { orderEvent } from "types";

export default {
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  isOpenHistory: Schema('boolean', 'primitive', { defaultValue: false }),
  isEditable: Schema('boolean', 'primitive', { defaultValue: false }),
  event: Schema(orderEvent, 'object', { defaultValue: {} }),
}

